import React from "react";
import useCryptoInUSD from "@/shared/hooks/useCryptoInUSD";
import usePaymentCurrency from "@/shared/hooks/usePaymentCurrency";
import useDisplayPrice from "@/shared/hooks/useDisplayPrice";
import { twMerge } from "tailwind-merge";

export interface Props {
  cryptoValue: number | string;
  paymentErc20TokenAddress: string;
  fiatPriceClassName?: string;
}

const ArtOrderCryptoValue = ({
  cryptoValue,
  paymentErc20TokenAddress,
  fiatPriceClassName,
}: Props) => {
  const paymentMethod = usePaymentCurrency(paymentErc20TokenAddress);

  const displayPrice = useDisplayPrice(cryptoValue, paymentMethod?.decimals);

  const { cryptoInUSD: priceInUSD } = useCryptoInUSD(
    displayPrice,
    paymentMethod?.id,
  );

  return (
    <span className="flex flex-col gap-y-1">
      <span className="text-lg leading-5">
        {displayPrice} {paymentMethod?.label}
      </span>
      <span
        className={twMerge(
          "text-body-3 text-endemicGray-700 endemic:text-secondary",
          fiatPriceClassName,
        )}
      >
        {priceInUSD} USD
      </span>
    </span>
  );
};

export default ArtOrderCryptoValue;
